module.exports = __webpack_public_path__ + "img/sanitaeranlagen.4897dcb.png";